import React from 'react';
import ManageGradeForm from '../Forms/manage_grade_form';
import { ManageDataPage } from './manageDataShared';

const COLUMNS = [
    { label: 'Grade Name', field: 'Name' },
    { label: 'Liner Outer', field: 'LinerOuter' },
    { label: 'Liner Inner', field: 'LinerInner' },
    { label: 'B-Flute 1', field: 'BFlute1' },
    { label: 'B-Plain', field: 'BFlute2' },
    { label: 'C-Flute', field: 'CFlute' },
    { label: 'P. Medium 1', field: 'PMedium1' },
    { label: 'P. Medium 2', field: 'PMedium2' },
];

function Manage_grade() {
    return (
        <ManageDataPage
            title="Manage Grade"
            endpoint="get_manage_grade_table"
            columns={COLUMNS}
            idKey="GradeID"
            FormComponent={ManageGradeForm}
            searchPlaceholder="Search grade or paper..."
        />
    );
}

export default Manage_grade;
